import { Injectable } from "@angular/core";

export interface NavigationItem {
  id: string;
  title: string;
  type: "item" | "collapse" | "group";
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}

const NavigationItemsGestao = [
  {
    id: "navigation",
    title: "Inicio",
    type: "group",
    icon: "feather icon-align-left",
    children: [
      {
        id: "home-gestao",
        title: "Pagina Inicial",
        type: "item",
        url: "/home-gestao",
        classes: "nav-item",
        icon: "feather icon-home",
      }
    ],
  },
  {
    id: "navigation",
    title: "Menu",
    type: "group",
    icon: "feather icon-align-left",
    children: [        
      {
        id: "agenda",
        title: "Agenda",
        type: "collapse",
        url: "/agenda",
        classes: "nav-item",
        icon: "feather icon-calendar",
        children: [
          {
            id: "agendar-horarios",
            title: "Agenda Geral",
            type: "item",
            url: "/agendar-horarios",
            classes: "nav-item",
            //icon: 'feather icon-sidebar'
          },
          {
            id: "minha-agenda",
            title: "Minha Agenda",
            type: "item",
            url: "/minha-agenda",
            classes: "nav-item",
            //icon: 'feather icon-sidebar'
          },
          {
            id: "agendar-atendimento",
            title: "Agendar Atendimento",
            type: "item",
            url: "/agendar-atendimento",
            classes: "nav-item",
            //icon: 'feather icon-sidebar'
          },
          {
            id: "disponibilizar-horarios",
            title: "Disponibilizar Horários",
            type: "item",
            url: "/disponibilizar-horarios",
            classes: "nav-item",
            //icon: 'feather icon-sidebar'
          }
        ]
      },    
      {
        id: "servicos-plataforma",
        title: "Serviços Plataforma",
        type: "collapse",
        url: "/servicos-plataforma",
        classes: "nav-item",
        icon: "feather icon-grid",
        children: [
          {
            id: "processo-judicial-italia",
            title: "Processo Judicial na Itália",
            type: "collapse",
            url: "/processo-judicial-italia",
            classes: "nav-item",           
            children: [              
              {
                id: "cidadania-via-paterna",
                title: "Cidadania Via Paterna",
                type: "item",
                url: "/cidadania-via-paterna",
                classes: "nav-item",
                //icon: 'feather icon-sidebar'
              },
              {
                id: "cidadania-via-materna",
                title: "Cidadania Via Materna",
                type: "item",
                url: "/cidadania-via-materna",
                classes: "nav-item",
                //icon: 'feather icon-sidebar'
              },
            ],
          },
          {
            id: "naturalizacao",
            title: "Naturalização",
            type: "collapse",
            url: "/naturalizacao",
            classes: "nav-item",           
            children: [              
              
            ],
          },
          {
            id: "aire",
            title: "AIRE",
            type: "collapse",
            url: "/aire",
            classes: "nav-item",           
            children: [              
              {
                id: "primeira-inscricao",
                title: "1º Inscrição",
                type: "item",
                url: "/primeira-inscricao",
                classes: "nav-item",
                //icon: 'feather icon-sidebar'
              },
              {
                id: "transferencia-circunscricao",
                title: "Transferência de circunscrição",
                type: "item",
                url: "/transferencia-circunscricao",
                classes: "nav-item",
                //icon: 'feather icon-sidebar'
              },
            ],
          },
          {
            id: "fast-it",
            title: "FAST IT",
            type: "collapse",
            url: "/fast-it",
            classes: "nav-item",           
            children: [              
              {
                id: "cadastro-consular",
                title: "Cadastro Consular",
                type: "item",
                url: "/cadastro-consular",
                classes: "nav-item",
                //icon: 'feather icon-sidebar'
              }
            ],
          },
          {
            id: "traducao",
            title: "Tradução",
            type: "collapse",
            url: "/traducao",
            classes: "nav-item",           
            children: [              
              {
                id: "certidao-registro-civil",
                title: "Certidão de registro civil",
                type: "item",
                url: "/certidao-registro-civil",
                classes: "nav-item",
                //icon: 'feather icon-sidebar'
              },
              {
                id: "documentos-escolares",
                title: "Documentos escolares",
                type: "item",
                url: "/documentos-escolares",
                classes: "nav-item",
                //icon: 'feather icon-sidebar'
              },
              {
                id: "outro",
                title: "Outro",
                type: "item",
                url: "/outro",
                classes: "nav-item",
                //icon: 'feather icon-sidebar'
              }
            ],
          },
          {
            id: "busca-documento",
            title: "Busca de Documentos",
            type: "collapse",
            url: "/busca-documento",
            classes: "nav-item",           
            children: [              
              {
                id: "certidao-brasileira-reg-civil",
                title: "Certidão Brasileira (registro civil)",
                type: "item",
                url: "/certidao-brasileira-reg-civil",
                classes: "nav-item",
                //icon: 'feather icon-sidebar'
              },
              {
                id: "certidao-brasileira-reg-religioso",
                title: "Certidão Brasileira (registro religioso)",
                type: "item",
                url: "/certidao-brasileira-reg-religioso",
                classes: "nav-item",
                //icon: 'feather icon-sidebar'
              },
              {
                id: "certidao-italiana-reg-civil",
                title: "Certidão Italiana (registro civil italiano)",
                type: "item",
                url: "/certidao-italiana-reg-civil",
                classes: "nav-item",
                //icon: 'feather icon-sidebar'
              },
              {
                id: "certidao-italiana-reg-religioso",
                title: "Certidão Italiana (registro religioso)",
                type: "item",
                url: "/certidao-italiana-reg-religioso",
                classes: "nav-item",
                //icon: 'feather icon-sidebar'
              }
            ],
          },
          {
            id: "consultoria",
            title: "Consultoria",
            type: "collapse",
            url: "/consultoria",
            classes: "nav-item",           
            children: [              
              {
                id: "analise-certidoes",
                title: "Análise de Certidões",
                type: "item",
                url: "/analise-certidoes",
                classes: "nav-item",
                //icon: 'feather icon-sidebar'
              }
            ],
          },
        ],
      },
      {
        id: "usuarios",
        title: "Clientes",
        type: "collapse",
        url: "/usuarios",
        classes: "nav-item",
        icon: "feather icon-users",
        children: [
          {
            id: "cadastrar-usuarios",
            title: "Cadastrar",
            type: "item",
            url: "/cadastrar-usuarios",
            classes: "nav-item",
            //icon: 'feather icon-sidebar'
          },
          {
            id: "usuarios-ativos",
            title: "Clientes Ativos",
            type: "item",
            url: "/usuarios-ativos",
            classes: "nav-item",
            //icon: 'feather icon-sidebar'
          },
          {
            id: "usuarios-inativos",
            title: "Clientes Inativos",
            type: "item",
            url: "/usuarios-inativos",
            classes: "nav-item",
            //icon: 'feather icon-sidebar'
          }
        ]
      },
      {
        id: "atendimento",
        title: "Atendimento",
        type: "collapse",
        url: "/atendimento",
        classes: "nav-item",
        icon: "feather icon-aperture",
        children: [
          {
            id: "consultar-atendimento",
            title: "Visualizar",
            type: "item",
            url: "/consultar-atendimento",
            classes: "nav-item",
            //icon: 'feather icon-sidebar'
          }
        ]
      }
    ],
  },
  {
    id: "navigation",
    title: "Administração",
    type: "group",
    icon: "feather icon-align-left",
    children: [        
      {
        id: "servicos",
        title: "Serviços",
        type: "collapse",
        url: "/servicos",
        classes: "nav-item",
        icon: "feather icon-award",
        children: [
          {
            id: "cadastro-tipo-servico",
            title: "Cadastrar Novo Serviço",
            type: "item",
            url: "/cadastro-tipo-servico",
            classes: "nav-item",
            //icon: 'feather icon-sidebar'
          }
        ],
      },
      
      {
        id: "modulistica",
        title: "Modulistica",
        type: "item",
        url: "/modulistica",
        classes: "nav-item",
        icon: "feather icon-file-text",
      },
      {
        id: "financeiro",
        title: "Financeiro",
        type: "collapse",
        url: "/financeiro",
        classes: "nav-item",
        icon: "fas fa-money-bill-wave",
        children: [
          {
            id: "dados-empresa",
            title: "Dados da Empresa",
            type: "item",
            url: "/dados-empresa",
            classes: "nav-item",
            //icon: 'feather icon-sidebar'
          }
        ]
      },
      {
        id: "mensagem-automatica",
        title: "Mensagens Automáticas",
        type: "item",
        url: "/mensagem-automatica",
        classes: "nav-item",
        icon: "feather icon-message-circle",
      },
      {
        id: "cadastro-responsavel",
        title: "Responsável",
        type: "item",
        url: "/cadastro-responsavel",
        classes: "nav-item",
        icon: "feather icon-user-check",
      },
      {
        id: "assessores",
        title: "Assessores",
        type: "collapse",
        url: "/assessores",
        classes: "nav-item",
        icon: "fas fa-people-carry",
        children: [
         // {
         //   id: "cadastro-assessor",
         //   title: "Cadastrar Assessor",
        //    type: "item",
         //   url: "/cadastro-assessor",
          //  classes: "nav-item",
            //icon: 'feather icon-sidebar'
          //},
          {
            id: "visualizar-assessor",
            title: "Elenco Assessores",
            type: "item",
            url: "/visualizar-assessor",
            classes: "nav-item",
            //icon: 'feather icon-sidebar'
          }
        ]
      },
      {
        id: "microservicos",
        title: "Microserviços",
        type: "collapse",
        url: "/microservicos",
        classes: "nav-item",
        icon: "feather icon-cpu",
        children: [
          {
            id: "cadastro-microservicos",
            title: "Cadastrar",
            type: "item",
            url: "/cadastro-microservicos",
            classes: "nav-item",
            //icon: 'feather icon-sidebar'
          },
          {
            id: "consultar-microservicos",
            title: "Consultar",
            type: "item",
            url: "/consultar-microservicos",
            classes: "nav-item",
            //icon: 'feather icon-sidebar'
          }
        ]
      }
    ],
  },
  {
    id: "navigation",
    title: "Financeiro",
    type: "group",
    icon: "feather icon-align-left",
    children: [
      {
        id: "fin-natureza-documento",
        title: "Natureza Documento",
        type: "item",
        url: "/fin-natureza-documento",
        classes: "nav-item",
        icon: "feather icon-file-text"
      },
      {
        id: "status-fornecedor",
        title: "Status Fornecedor",
        type: "item",
        url: "/status-fornecedor",
        classes: "nav-item",
        icon: "feather icon-layers"
      },
      {
        id: "tipo-pagamento",
        title: "Tipos de Pagamento",
        type: "item",
        url: "/tipo-pagamento",
        classes: "nav-item",
        icon: "feather icon-credit-card"
      },
      {
        id: "fin-documento",
        title: "Documentos",
        type: "item",
        url: "/fin-documento",
        classes: "nav-item",
        icon: "feather icon-file"
      },
      {
        id: "fornecedor",
        title: "Fornecedor",
        type: "collapse",
        url: "/fornecedor",
        classes: "nav-item",
        icon: "feather icon-aperture",
        children: [          
                {
                  id: "cadastrar-fornecedor",
                  title: "Cadastrar",
                  type: "item",
                  url: "/cadastrar-fornecedor",
                  classes: "nav-item",
                  icon: "feather icon-user-plus"
                },
                {
                  id: "consultar-fornecedor",
                  title: "Consultar",
                  type: "item",
                  url: "/consultar-fornecedor",
                  classes: "nav-item",
                  icon: "feather icon-users"
                }
        ]
      },
      {
        id: "tabela-precos-fin",
        title: "Tabela de Preços",
        type: "collapse",
        url: "/tabela-precos-fin",
        classes: "nav-item",
        icon: "fas fa-money-bill-wave",
        children: [
          {
            id: "cadastrar-tabela-preco-fin",
            title: "Cadastrar",
            type: "item",
            url: "/cadastrar-tabela-preco-fin",
            classes: "nav-item"
          },
          {
            id: "consultar-tabela-preco-fin",
            title: "Consultar",
            type: "item",
            url: "/consultar-tabela-preco-fin",
            classes: "nav-item"
          }
        ]
      },
      {
        id: "contas-pagar",
        title: "Contas Pagar",
        type: "collapse",
        url: "/contas-pagar-menu",
        classes: "nav-item",
        icon: "feather icon-credit-card",
        children: [
          {
            id: "contas-pagar-cadastrar",
            title: "Cadastrar",
            type: "item",
            url: "/contas-pagar",
            classes: "nav-item"
          },
          {
            id: "contas-pagar-consultar",
            title: "Consultar",
            type: "item",
            url: "/consultar-contas-pagar",
            classes: "nav-item"
          }
        ]
      },
      {
        id: "contas-receber",
        title: "Contas a Receber",
        type: "collapse",
        url: "/contas-receber-menu",
        classes: "nav-item",
        icon: "fas fa-money-check-alt",
        children: [
          {
            id: "contas-receber-cadastrar",
            title: "Cadastrar",
            type: "item",
            url: "/contas-receber",
            classes: "nav-item"
          },
          {
            id: "contas-receber-consultar",
            title: "Consultar",
            type: "item",
            url: "/consultar-contas-receber",
            classes: "nav-item"
          },
          {
            id: "contas-receber-gerar-boleto",
            title: "Gerar Boleto",
            type: "item",
            url: "/gerar-boleto",
            classes: "nav-item"
          },
          {
            id: "contas-receber-config-cnab-santander",
            title: "Configuração API Santander",
            type: "item",
            url: "/configuracao-cnab-santander",
            classes: "nav-item"
          },
          {
            id: "contas-receber-config-banrisul",
            title: "Configuração API Banrisul",
            type: "item",
            url: "/configuracao-api-banrisul",
            classes: "nav-item"
          }
        ]
      },
      {
        id: "importar-extrato-banco",
        title: "Importar Extrato Banco 1",
        type: "item",
        url: "/importar-extrato-banco",
        classes: "nav-item",
        icon: "feather icon-download"
      },
      {
        id: "plano-contas-tree",
        title: "Plano de Contas",
        type: "item",
        url: "/plano-contas-tree",
        classes: "nav-item",
        icon: "feather icon-list"
      },
      {
        id: "centro-custos",
        title: "Centro de Custos",
        type: "item",
        url: "/centro-custos",
        classes: "nav-item",
        icon: "feather icon-layers"
      },
      {
        id: "fluxo-caixa",
        title: "Fluxo Caixa (Plano de Contas)",
        type: "item",
        url: "/fluxo-caixa",
        classes: "nav-item",
        icon: "feather icon-bar-chart-2"
      },
      {
        id: "analise-centro-custos",
        title: "Análise Centros de Custos",
        type: "item",
        url: "/analise-centro-custos",
        classes: "nav-item",
        icon: "feather icon-grid"
      },
      {
        id: "fluxo-caixa-diario-projetado",
        title: "Fluxo de Caixa Diário Projetado",
        type: "item",
        url: "/fluxo-caixa-diario-projetado",
        classes: "nav-item",
        icon: "feather icon-trending-up"
      },
      {
        id: "fluxo-caixa-diario-realizado",
        title: "Fluxo de Caixa Diário Realizado",
        type: "item",
        url: "/fluxo-caixa-diario-realizado",
        classes: "nav-item",
        icon: "feather icon-check-circle"
      },
      {
        id: "banco-santander",
        title: "Santander",
        type: "item",
        url: "/banco-santander",
        classes: "nav-item",
        icon: "feather icon-credit-card"
      }
    ],
  }
];





const NavigationItemsOperadora = [
  {
    id: "navigation",
    title: "Perfil Operadora",
    type: "group",
    icon: "feather icon-align-left",
    children: [
      {
        id: "home-operadora",
        title: "Home",
        type: "item",
        url: "/home-operadora",
        classes: "nav-item",
        icon: "feather icon-home",
      },
      {
        id: "cadastro-usuario-operadora",
        title: "Clientes",
        type: "item",
        url: "/cadastro-usuario-operadora",
        classes: "nav-item",
        icon: "feather icon-user",
      },
      {
        id: "parceiro",
        title: "Parceiros",
        type: "collapse",
        url: "/parceiro",
        classes: "nav-item",
        icon: "feather icon-users",
        children: [
          {
            id: "pre-cadastro-cliente",
            title: "Pré-Cadastro",
            type: "item",
            url: "/pre-cadastro-cliente",
            classes: "nav-item",
            //icon: 'feather icon-sidebar'
          },
          {
            id: "cadastro-cliente",
            title: "Cadastrar",
            type: "item",
            url: "/cadastro-cliente",
            classes: "nav-item",
            //icon: 'feather icon-sidebar'
          },
        ],
      },
      {
        id: "auditoria-operadora",
        title: "Auditorias",
        type: "item",
        url: "/auditoria-operadora",
        classes: "nav-item",
        icon: "feather icon-sidebar",
      },
      {
        id: "relatorio",
        title: "Relatórios",
        type: "item",
        url: "/relatorio",
        classes: "nav-item",
        icon: "feather icon-activity",
      },
      {
        id: "comunicacao",
        title: "Comunicação Geral",
        type: "item",
        url: "/comunicacao",
        classes: "nav-item",
        icon: "feather icon-message-circle",
      },
      {
        id: "agendamento",
        title: "Agenda",
        type: "item",
        icon: "feather icon-calendar",
        url: "/agendamento",
      },
    ],
  },
  {
    id: "Suporte",
    title: "Suporte",
    type: "collapse",
    icon: "feather icon-message-square",
    children: [
      {
        id: "Solicitar suporte",
        title: "Solicitar suporte",
        type: "item",
        url: "/Solicitar suporte",
        classes: "nav-item",
      },

      {
        id: "Manual de Preparação para Auditorias",
        title: "Manual de Preparação para Auditorias",
        type: "item",
        url: "/Manual de Preparação para Auditorias",
        classes: "nav-item",
      },
    ],
  },
];

const NavigationItemsCliente = [
  {
    id: "navigation",
    title: "Perfil Cliente",
    type: "group",
    icon: "feather icon-align-left",
    children: [
      {
        id: "home-cliente",
        title: "Home",
        type: "item",
        url: "/home-cliente",
        classes: "nav-item",
        icon: "feather icon-home",
      },
      {
        id: "perfil-cliente",
        title: "Perfil",
        type: "item",
        url: "/perfil-cliente",
        classes: "nav-item",
        icon: "feather icon-user",
      },
      {
        id: "chat-cliente",
        title: "Chat",
        type: "item",
        url: "/chat-cliente",
        classes: "nav-item",
        icon: "feather icon-message-circle",
      },
      {
        id: "documentos",
        title: "Documentos",
        type: "item",
        url: "/documentos",
        classes: "nav-item",
        icon: "feather icon-upload-cloud",
      },
    ],
  },
];

const NavigationItemsEmpresa = [
  {
    id: "navigation",
    title: "Perfil Cliente",
    type: "group",
    icon: "feather icon-align-left",
    children: [
      {
        id: "home-empresa",
        title: "Home",
        type: "item",
        url: "/home-empresa",
        classes: "nav-item",
        icon: "feather icon-home",
      },
      {
        id: "status-cliente",
        title: "Status Cliente",
        type: "item",
        url: "/status-cliente",
        classes: "nav-item",
        icon: "feather icon-home",
      },
      {
        id: "cadastro-cliente",
        title: "Cadastro Cliente",
        type: "item",
        url: "/cadastro-cliente",
        classes: "nav-item",
        icon: "feather icon-home",
      },
      
      {
        id: "cadastro-advogado",
        title: "Cadastro Advogado",
        type: "item",
        url: "/cadastro-advogado",
        classes: "nav-item",
        icon: "feather icon-home",
      },
      {
        id: "cadastro-cartorio",
        title: "Cadastro Cartorio",
        type: "item",
        url: "/cadastro-cartorio",
        classes: "nav-item",
        icon: "feather icon-home",
      },
      {
        id: "cadastro-tradutor",
        title: "Cadastro Tradutor",
        type: "item",
        url: "/cadastro-tradutor",
        classes: "nav-item",
        icon: "feather icon-home",
      },
      {
        id: "cadastro-pesquisador",
        title: "Cadastro Pesquisador",
        type: "item",
        url: "/cadastro-pesquisador",
        classes: "nav-item",
        icon: "feather icon-home",
      },
    ],
  },
];

@Injectable()
export class NavigationItem {
  public get(ehTriagem: string) {
    /*if(ehTriagem == "Gestao")
      return NavigationItemsGestao;
    else
      return NavigationItemsGestao;*/

      
    switch (ehTriagem) {
      case "Gestao":
        return NavigationItemsGestao;
        break;
      case "Empresa":
        return NavigationItemsEmpresa;
        break;
      case "Operadora":
        return NavigationItemsOperadora;
        break;
      case "Cliente":
        return NavigationItemsCliente;
        break;
      default:
        return NavigationItemsGestao;
    }
  }
}

export const navigation = [
  {
    id: "cronograma-base",
    title: "Cronograma Base",
    type: "item",
    url: "/cronograma-base",
    classes: "nav-item",
  },
  {
    id: "cronograma-cliente",
    title: "Cronograma Cliente",
    type: "item",
    url: "/cronograma-cliente",
    classes: "nav-item",
  },
  {
    id: "usuario-cliente",
    title: "Usuário Cliente",
    type: "item",
    url: "/usuario-cliente",
    classes: "nav-item",
  },
  {
    id: "qualificacao-documental",
    title: "Qualificação Documental",
    type: "item",
    url: "/qualificacao-documental",
    classes: "nav-item",
  },
  {
    id: "checklist-cliente",
    title: "Checklist Cliente",
    type: "item",
    url: "/checklist-cliente",
    classes: "nav-item",
  },
];
